const featureHR = {
    "view": {
        "table": {
            "title": "Zahtjevi za značajke",
            "column": {
                "release_name": "Ime",
                "release_artist_name": "Ime izvođača izdanja",
                "release_date": "Datum izdanja",
                "exclusive_date": "Ekskluzivni datum"
            },
            "button": {
                "export_csv": "Izvoz CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija."
        }
    },
    "add": {
        "title": "Marketinške činjenice",
        "form": {
            "label": {
                "release": "Izdanje",
                "djTastemaker": "DJ / TasteMaker povratne informacije:",
                "radioSupport": "Radio podrška",
                "marketingPR": "Marketing / PR",
                "labelReach": "Dohvat izdavačke kuće i izvođača:"
            },
            "help_text": {
                "release": "Odaberite izdanje za koje želite poslati zahtjev za značajku. Možete vidjeti i odabrati samo izdanja koja imaju opći datum izdanja 22 ili više dana unaprijed. Ako ciljate na ekskluzivni datum izdanja, molimo osigurajte da pošaljete ovaj obrazac najmanje 22 dana prije (prvog) ekskluzivnog datuma izdanja.",
                "djTastemaker": "Unesite 10 DJ / Radio / Magazin povratnih informacija u formatu 'Ime - Povratna informacija' (Unesite svaku povratnu informaciju u jedan red). Podnesci koji sadrže 'preuzimanje za' neće biti promovirani ili poslani u online trgovine.",
                "radioSupport": "Je li vaša pjesma ili izdanje predstavljeno na nekim radio postajama? Ako jest, navedite postaju i unesite odgovarajuću poveznicu na njihovu stranicu gdje je vidljivo da promoviraju ili puštaju vaše pjesme.",
                "marketingPR": "(Intervjui, blogovi, recenzije, članci u časopisima) - Molimo navedite sve dogovorene aktivnosti za tisak i marketing za ovo izdanje. Nije obavezno, ali je izuzetno važno da se istaknete iz konkurencije.",
                "labelReach": "Ukupan broj pratitelja (izdavačka kuća i izvođači) na Facebooku, Instagramu, SoundCloudu i YouTubeu. <strong>Molimo stavite svaku platformu i broj pratitelja u novi red</strong>."
            },
            "button": {
                "submit": "Pošalji"
            },
            "message": {
                "releaseRequired": "Postojeće izdanje je potrebno",
                "featureRequestAlreadyExists": "Zahtjev za značajku za ovo izdanje je već napravljen"
            }
        },
        "message": {
            "success": "Zahtjev za značajku je dodan!",
            "error": "Nešto je pošlo po krivu! Molimo osvježite stranicu i pokušajte ponovno!"
        },
        "modal": {
            "confirm": {
                "header": "Novi zahtjev za značajku",
                "body": "Ovaj zahtjev za značajku mora biti poslan najmanje 21 dan prije prvog (ekskluzivnog ili općeg, što god dođe prvo) datuma. Nažalost, kasni podnesci ne mogu biti uzeti u obzir. Želite li poslati svoj zahtjev za značajku?"
            }
        }
    }
};

export default featureHR;